import { render } from "./Docs.vue?vue&type=template&id=661be6cd"
import script from "./Docs.vue?vue&type=script&lang=js"
export * from "./Docs.vue?vue&type=script&lang=js"
script.render = render

export default script